import styled from "styled-components";
import { Button } from "antd";

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    flex-direction: column;
    width: 100%;
    gap: 0.75rem;
  }
`;

export const StyledButton = styled(Button)`
  && {
    height: 30px;
    padding: 0 1rem;
    font-size: 0.9rem;
    font-weight: 500;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    /* Default Button (Send back) */
    &.ant-btn-default {
      border: 1.5px solid #e5e7eb;
      background: #ffffff;
      color: #374151;

      &:hover {
        border-color: #6366f1;
        color: #6366f1;
        background: #f5f3ff;
        transform: translateX(-2px);
      }

      &:active {
        border-color: #4f46e5;
        color: #4f46e5;
      }
    }

    /* Primary Button (Forward) */
    &.ant-btn-primary {
      background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
      border: none;
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);

      &:hover {
        background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
        box-shadow: 0 6px 16px rgba(99, 102, 241, 0.35);
        transform: translateX(2px);
      }

      &:active {
        background: linear-gradient(135deg, #4338ca 0%, #6d28d9 100%);
      }
    }

    /* Icon styling */
    .anticon {
      font-size: 1rem;
    }

    @media (max-width: 576px) {
      width: 100%;
      justify-content: center;
      height: 48px;
      font-size: 0.95rem;
    }
  }
`;
